<template>
  <v-dialog
    v-model="connect_dialog"
    persistent
    width="400"
    :scrim="false"
    :content-class="is_mobile ? 'calendar-dialog pa-4' : 'calendar-dialog pa-8'"
  >
    <div v-if="!success" class="d-flex flex-column">
      <div class="header d-flex">
        <span class="header-title my-auto">
          {{
            $i18n.locale == "nl" ? "Koppel je agenda" : "Connect your calendar"
          }}
        </span>
        <v-btn
          icon
          dark
          variant="text"
          class="ml-auto mr-n4 mt-n4"
          @click="$emit('close-dialog')"
          style="position: relative; top: 6px"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <span class="mt-4">
        {{
          $i18n.locale == "nl"
            ? "Wil je je agenda koppelen, zodat activiteiten automatisch worden toegevoegd?"
            : "Want to connect your calendar so activities are added automatically?"
        }}
      </span>
      <span class="mt-6">
        {{
          $i18n.locale == "nl"
            ? "Kies je agenda om te verbinden:"
            : "Choose your calendar to connect:"
        }}
      </span>
      <div
        class="agenda-row mt-4"
        :class="selectedType == 'outlook' ? 'active-agenda-row' : ''"
        @click="
          selectedType == 'outlook'
            ? connect(selectedType)
            : (selectedType = 'outlook')
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="24"
          viewBox="0 0 26 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5875_39417)">
            <path
              d="M25.8993 12.6002C25.9007 12.3985 25.7965 12.2107 25.6245 12.1052H25.6215L25.6107 12.0992L16.6707 6.80725C16.6321 6.78117 16.592 6.75733 16.5507 6.73586C16.2055 6.55777 15.7955 6.55777 15.4503 6.73586C15.4089 6.75734 15.3689 6.78117 15.3303 6.80725L6.39031 12.0992L6.37951 12.1052C6.10628 12.2752 6.02251 12.6344 6.19243 12.9076C6.24249 12.9882 6.31144 13.0552 6.39331 13.103L15.3333 18.395C15.372 18.4209 15.4121 18.4447 15.4533 18.4665C15.7985 18.6445 16.2085 18.6445 16.5537 18.4665C16.5949 18.4447 16.635 18.4209 16.6737 18.395L25.6137 13.103C25.7923 12.9989 25.9013 12.807 25.8993 12.6002Z"
              fill="#0A2767"
            />
            <path
              d="M7.43232 9.0666H13.2991V14.4444H7.43232V9.0666ZM24.6991 3.6V1.13999C24.7132 0.524937 24.2264 0.0147381 23.6113 0H8.38693C7.77187 0.0147381 7.28504 0.524937 7.29913 1.13999V3.6L16.2991 5.99999L24.6991 3.6Z"
              fill="#0364B8"
            />
            <path
              d="M7.2998 3.59961H13.2998V8.9996H7.2998V3.59961Z"
              fill="#0078D4"
            />
            <path
              d="M19.2998 3.59961H13.2998V8.9996L19.2998 14.3996H24.6998V8.9996L19.2998 3.59961Z"
              fill="#28A8EA"
            />
            <path d="M13.2998 9H19.2998V14.4H13.2998V9Z" fill="#0078D4" />
            <path
              d="M13.2998 14.4004H19.2998V19.8004H13.2998V14.4004Z"
              fill="#0364B8"
            />
            <path
              d="M7.43262 14.4446H13.2994V19.3334H7.43262V14.4446Z"
              fill="#14447D"
            />
            <path
              d="M19.2998 14.4004H24.6998V19.8004H19.2998V14.4004Z"
              fill="#0078D4"
            />
            <path
              d="M25.6248 13.0694L25.6134 13.0754L16.6734 18.1034C16.6344 18.1274 16.5948 18.1502 16.5534 18.1706C16.4015 18.2429 16.2366 18.2837 16.0686 18.2906L15.5802 18.005C15.5389 17.9843 15.4989 17.9613 15.4602 17.936L6.40021 12.7652H6.39601L6.09961 12.5996V22.778C6.10423 23.4571 6.65832 24.0039 7.3374 23.9996H24.681C24.6912 23.9996 24.7002 23.9948 24.711 23.9948C24.8544 23.9856 24.9958 23.9561 25.131 23.9072C25.1894 23.8825 25.2458 23.8532 25.2996 23.8196C25.3398 23.7968 25.4088 23.747 25.4088 23.747C25.7161 23.5196 25.8981 23.1604 25.8996 22.778V12.5996C25.8994 12.7943 25.7944 12.9738 25.6248 13.0694Z"
              fill="url(#paint0_linear_5875_39417)"
            />
            <path
              opacity="0.5"
              d="M25.419 12.5602V13.1842L16.071 19.6204L6.39302 12.7702C6.39302 12.7669 6.39033 12.7642 6.38702 12.7642L5.49902 12.2302V11.7802L5.86503 11.7742L6.63902 12.2182L6.65701 12.2242L6.72301 12.2662C6.72301 12.2662 15.819 17.4562 15.843 17.4682L16.191 17.6722C16.221 17.6602 16.251 17.6482 16.287 17.6362C16.305 17.6242 25.317 12.5542 25.317 12.5542L25.419 12.5602Z"
              fill="#0A2767"
            />
            <path
              d="M25.6248 13.0694L25.6134 13.076L16.6734 18.104C16.6344 18.128 16.5948 18.1508 16.5534 18.1712C16.2062 18.3408 15.8002 18.3408 15.453 18.1712C15.4119 18.1508 15.3718 18.1284 15.333 18.104L6.39301 13.076L6.38221 13.0694C6.20961 12.9758 6.1014 12.7959 6.09961 12.5996V22.778C6.10391 23.457 6.6578 24.0039 7.33675 23.9996C7.33675 23.9996 7.33678 23.9996 7.33681 23.9996H24.6624C25.3414 24.0039 25.8953 23.457 25.8996 22.7781C25.8996 22.7781 25.8996 22.778 25.8996 22.778V12.5996C25.8994 12.7943 25.7944 12.9738 25.6248 13.0694Z"
              fill="#1490DF"
            />
            <path
              opacity="0.1"
              d="M16.8035 18.0293L16.6697 18.1043C16.6309 18.129 16.5909 18.1516 16.5497 18.1721C16.4023 18.2445 16.242 18.2869 16.0781 18.2969L19.4795 22.3193L25.4129 23.7491C25.5755 23.6263 25.7048 23.4648 25.7891 23.2793L16.8035 18.0293Z"
              fill="black"
            />
            <path
              opacity="0.05"
              d="M17.4095 17.6895L16.6697 18.1052C16.6309 18.1299 16.5909 18.1526 16.5497 18.1731C16.4023 18.2454 16.242 18.2878 16.0781 18.2978L17.6717 22.6916L25.4147 23.7482C25.7197 23.5192 25.8993 23.1601 25.8995 22.7786V22.6472L17.4095 17.6895Z"
              fill="black"
            />
            <path
              d="M7.35361 23.9996H24.6606C24.9269 24.0009 25.1866 23.9168 25.4016 23.7596L15.5796 18.0062C15.5383 17.9855 15.4983 17.9625 15.4596 17.9372L6.3996 12.7664H6.3954L6.09961 12.5996V22.7432C6.09893 23.4364 6.66036 23.9989 7.35361 23.9996Z"
              fill="#28A8EA"
            />
            <path
              opacity="0.1"
              d="M14.4996 5.89984V18.6978C14.4985 19.1465 14.2257 19.5499 13.8096 19.7178C13.6807 19.7732 13.5419 19.8018 13.4016 19.8018H6.09961V5.40004H7.29961V4.80005H13.4016C14.0078 4.80235 14.4983 5.29369 14.4996 5.89984Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M13.8996 6.50024V19.2982C13.9011 19.4432 13.8704 19.5866 13.8096 19.7182C13.643 20.1289 13.2448 20.3984 12.8016 20.4004H6.09961V5.40044H12.8016C12.9757 5.39869 13.1473 5.44212 13.2996 5.52645C13.6674 5.71175 13.8995 6.0884 13.8996 6.50024Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M13.8996 6.50024V18.0982C13.8967 18.7041 13.4075 19.1952 12.8016 19.2004H6.09961V5.40044H12.8016C12.9757 5.39869 13.1473 5.44212 13.2996 5.52645C13.6674 5.71175 13.8995 6.0884 13.8996 6.50024Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M13.2996 6.50019V18.0982C13.299 18.705 12.8084 19.1974 12.2016 19.2004H6.09961V5.40039H12.2016C12.8083 5.40071 13.2999 5.89285 13.2996 6.49959C13.2996 6.49979 13.2996 6.49999 13.2996 6.50019Z"
              fill="black"
            />
            <path
              d="M1.1994 5.40039H12.1998C12.8072 5.40039 13.2996 5.89279 13.2996 6.50019V17.5006C13.2996 18.108 12.8072 18.6004 12.1998 18.6004H1.1994C0.591999 18.6004 0.0996094 18.108 0.0996094 17.5006V6.50019C0.0996094 5.89279 0.592013 5.40039 1.1994 5.40039Z"
              fill="url(#paint1_linear_5875_39417)"
            />
            <path
              d="M3.53669 10.0128C3.80775 9.43529 4.24527 8.95199 4.79309 8.62502C5.39977 8.27769 6.09051 8.10454 6.78929 8.12461C7.43694 8.11057 8.07601 8.27474 8.63669 8.59921C9.16386 8.91358 9.58843 9.37422 9.85889 9.92521C10.1534 10.5323 10.3002 11.2005 10.2873 11.8752C10.3016 12.5803 10.1505 13.279 9.84629 13.9152C9.56939 14.4859 9.13135 14.9629 8.58629 15.2874C8.00399 15.6218 7.3412 15.7903 6.6699 15.7746C6.00841 15.7906 5.35526 15.6245 4.78169 15.2946C4.24997 14.9798 3.82007 14.5187 3.5433 13.9662C3.24701 13.3678 3.09847 12.7072 3.1101 12.0396C3.09776 11.3405 3.24359 10.6476 3.53669 10.0128ZM4.87589 13.2708C5.02041 13.6359 5.26549 13.9526 5.58268 14.184C5.90577 14.4098 6.29264 14.5263 6.68668 14.5164C7.10632 14.533 7.51996 14.4125 7.86508 14.1732C8.17826 13.9425 8.4169 13.625 8.55147 13.26C8.70191 12.8524 8.77615 12.4206 8.77048 11.9862C8.77513 11.5476 8.70534 11.1114 8.56407 10.6962C8.4393 10.3213 8.20836 9.99074 7.89928 9.74461C7.56281 9.49395 7.15028 9.36682 6.73107 9.38461C6.3285 9.37419 5.93296 9.4916 5.60128 9.72001C5.27872 9.95244 5.02899 10.2719 4.88128 10.641C4.55362 11.4871 4.55191 12.4247 4.87648 13.272L4.87589 13.2708Z"
              fill="white"
            />
            <path
              d="M19.2998 3.59961H24.6998V8.9996H19.2998V3.59961Z"
              fill="#50D9FF"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_5875_39417"
              x1="15.9996"
              y1="12.5996"
              x2="15.9996"
              y2="23.9996"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#35B8F1" />
              <stop offset="1" stop-color="#28A8EA" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_5875_39417"
              x1="2.39271"
              y1="4.54103"
              x2="11.0065"
              y2="19.4597"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1784D9" />
              <stop offset="0.5" stop-color="#107AD5" />
              <stop offset="1" stop-color="#0A63C9" />
            </linearGradient>
            <clipPath id="clip0_5875_39417">
              <rect
                width="25.8"
                height="24"
                fill="white"
                transform="translate(0.0996094)"
              />
            </clipPath>
          </defs>
        </svg>
        <span class="ml-2">Microsoft Outlook</span>
      </div>
      <div
        :class="selectedType == 'google' ? 'active-agenda-row' : ''"
        class="agenda-row mb-8 mt-2"
        @click="
          selectedType == 'google'
            ? connect(selectedType)
            : (selectedType = 'google')
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_5875_39441)">
            <path
              d="M18.316 5.68442L12.6318 5.05286L5.68441 5.68442L5.05273 12.0003L5.68429 18.3161L12.0001 19.1056L18.316 18.3161L18.9475 11.8425L18.316 5.68442Z"
              fill="white"
            />
            <path
              d="M8.27525 15.4828C7.80317 15.1638 7.47629 14.6981 7.29785 14.0823L8.39369 13.6307C8.49317 14.0097 8.66681 14.3033 8.91473 14.5118C9.16109 14.7202 9.46109 14.8228 9.81161 14.8228C10.1701 14.8228 10.478 14.7138 10.7353 14.4959C10.9925 14.278 11.1221 14.0001 11.1221 13.6638C11.1221 13.3197 10.9863 13.0385 10.7147 12.8207C10.4432 12.6029 10.1021 12.4938 9.69473 12.4938H9.06161V11.4092H9.62993C9.98045 11.4092 10.2758 11.3145 10.5158 11.125C10.7558 10.9355 10.8758 10.6766 10.8758 10.3466C10.8758 10.0529 10.7684 9.81916 10.5537 9.64396C10.339 9.46876 10.0673 9.38032 9.73733 9.38032C9.41525 9.38032 9.15941 9.46564 8.96993 9.63772C8.78045 9.8098 8.64305 10.0214 8.55629 10.2708L7.47161 9.81928C7.61525 9.41188 7.87901 9.05188 8.26577 8.74084C8.65265 8.4298 9.14681 8.27344 9.74681 8.27344C10.1905 8.27344 10.5899 8.35876 10.9437 8.53084C11.2973 8.70292 11.5753 8.94136 11.7758 9.24448C11.9763 9.54916 12.0758 9.89032 12.0758 10.2692C12.0758 10.656 11.9827 10.9828 11.7963 11.2512C11.6099 11.5197 11.381 11.7249 11.1094 11.8686V11.9333C11.4679 12.0833 11.7599 12.3123 11.9905 12.6202C12.2194 12.9281 12.3346 13.296 12.3346 13.7255C12.3346 14.155 12.2257 14.5386 12.0077 14.875C11.7898 15.2114 11.4883 15.4766 11.1062 15.6692C10.7225 15.8618 10.2915 15.9597 9.81305 15.9597C9.25889 15.9612 8.74733 15.8018 8.27525 15.4828Z"
              fill="#1A73E8"
            />
            <path
              d="M14.9996 10.0448L13.8027 10.9148L13.2012 10.0022L15.3596 8.44531H16.187V15.789H14.9996V10.0448Z"
              fill="#1A73E8"
            />
            <path
              d="M18.3159 24.0001L24 18.316L21.1579 17.0529L18.3159 18.316L17.0527 21.1581L18.3159 24.0001Z"
              fill="#EA4335"
            />
            <path
              d="M4.4209 21.1585L5.68402 24.0006H18.3156V18.3164H5.68402L4.4209 21.1585Z"
              fill="#34A853"
            />
            <path
              d="M1.89468 0C0.84792 0 0 0.84792 0 1.89468V18.3157L2.84208 19.5788L5.68416 18.3157V5.68416H18.3157L19.5788 2.84208L18.3158 0H1.89468Z"
              fill="#4285F4"
            />
            <path
              d="M0 18.3164V22.1059C0 23.1528 0.84792 24.0006 1.89468 24.0006H5.68416V18.3164H0Z"
              fill="#188038"
            />
            <path
              d="M18.3154 5.6839V18.3155H23.9996V5.6839L21.1575 4.42078L18.3154 5.6839Z"
              fill="#FBBC04"
            />
            <path
              d="M23.9996 5.68416V1.89468C23.9996 0.8478 23.1517 0 22.1049 0H18.3154V5.68416H23.9996Z"
              fill="#1967D2"
            />
          </g>
          <defs>
            <clipPath id="clip0_5875_39441">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span class="ml-2">Google Calendar</span>
      </div>
      <span
        @click="selectedType ? connect(selectedType) : ''"
        block
        class="agenda-btn"
      >
        {{ $i18n.locale == "nl" ? "Verbind mijn agenda" : "Connect my agenda" }}
      </span>
      <div class="footer mt-4" :class="is_mobile ? '' : 'd-flex'">
        <a
          :class="is_mobile ? 'd-block' : 'mr-8'"
          @click="remindMeLater('remind_me_later')"
        >
          {{ $i18n.locale == "nl" ? "Herinner mij later" : "Remind me later" }}
        </a>
        <a
          @click="remindMeLater('not_interested')"
          :class="is_mobile ? 'd-block mt-4' : ''"
        >
          {{ $i18n.locale == "nl" ? "Niet geïnteresseerd" : "Not interested" }}
        </a>
      </div>
    </div>
    <div v-else class="d-flex flex-column ga-4">
      <div class="d-flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <mask
            id="mask0_6005_38487"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="40"
            height="40"
          >
            <rect width="40" height="40" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_6005_38487)">
            <path
              d="M17.583 27.6113L29.3609 15.8334L27.3051 13.8055L17.583 23.528L12.6663 18.6113L10.6384 20.6388L17.583 27.6113ZM19.9997 36.6667C17.7127 36.6667 15.5554 36.2292 13.5276 35.3542C11.4998 34.4792 9.7312 33.2871 8.22176 31.778C6.71259 30.2685 5.52051 28.4999 4.64551 26.4721C3.77051 24.4443 3.33301 22.287 3.33301 20C3.33301 17.6945 3.77051 15.5278 4.64551 13.5C5.52051 11.4723 6.71259 9.70837 8.22176 8.20837C9.7312 6.70837 11.4998 5.52087 13.5276 4.64587C15.5554 3.77087 17.7127 3.33337 19.9997 3.33337C22.3052 3.33337 24.4719 3.77087 26.4997 4.64587C28.5275 5.52087 30.2913 6.70837 31.7913 8.20837C33.2913 9.70837 34.4788 11.4723 35.3538 13.5C36.2288 15.5278 36.6663 17.6945 36.6663 20C36.6663 22.287 36.2288 24.4443 35.3538 26.4721C34.4788 28.4999 33.2913 30.2685 31.7913 31.778C30.2913 33.2871 28.5275 34.4792 26.4997 35.3542C24.4719 36.2292 22.3052 36.6667 19.9997 36.6667Z"
              fill="#70CC14"
            />
          </g>
        </svg>
        <v-btn
          icon
          dark
          variant="text"
          class="ml-auto mr-n4 mt-n4"
          @click="handleCloseDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="header">
        <span class="header-title">
          {{
            $i18n.locale == "nl"
              ? "Agenda succesvol gekoppeld!"
              : "Calendar successfully linked!"
          }}
        </span>
      </div>
      <div c>
        <span :class="is_mobile ? '' : 'text-center'">
          {{
            $i18n.locale == "nl"
              ? "Je agenda is succesvol gekoppeld! Vanaf nu worden al je afspraken automatisch gesynchroniseerd."
              : "Your calendar has been successfully linked! From now on, all your appointments will be automatically synchronized."
          }}
        </span>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { useMainStore } from "../stores/store";
import api from "../services/api";
import config from "../config";
import isMobile from "@/mixins/isMobile";
window.addEventListener("message", (event) => {
  if (event.data?.type === "calendar_connected") {
    const mainStore = useMainStore();

    mainStore.$patch({
      calendar_connected: true,
      user: {
        ...mainStore.user,

        ...(event.data?.calendar_type === "google" && { google: true }),
        ...(event.data?.calendar_type === "outlook" && { outlook: true }),
      },
    });
  }
});

export default {
  mixins: [isMobile],
  components: {},
  props: {},
  data: () => ({
    selectedType: "",
    delete_dialog: false,
    success: false,
    changed: false,
    change_dialog: false,
    confirm_dialog: false,

    mainstore: useMainStore(),
  }),
  watch: {
    "mainstore.calendar_connected"(newVal) {
      if (newVal) {
        this.success = true;
      }
    },
  },

  methods: {
    handleCloseDialog() {
      const mainStore = useMainStore();
      mainStore.$patch({ calendar_connected: false });

      // wait ~50ms before closing the dialog
      setTimeout(() => {
        this.$emit("close-dialog");
      }, 50);
    },
    connect(type) {
      // Open tijdelijk popupvenster om popup-blokkade te omzeilen
      const popup = window.open("", "_blank", "width=500,height=700");

      // Doe daarna pas de API-call
      api
        .get(`${config.url.api}/v1/auth/connect?type=${type}`)
        .then((res) => {
          if (res.data.success && popup) {
            popup.location.href = res.data.url; // stuur popup naar de echte URL
          } else if (popup) {
            popup.close(); // sluit als het misgaat
          }
        })
        .catch(() => {
          if (popup) popup.close();
        });
    },

    remindMeLater(type) {
      api
        .post(`${config.url.api}/v1/users/0/remind_me_later`, {
          type: type,
        })
        .then((res) => {
          if (res.data.success) {
            this.$emit("close-dialog");
          }
        })
        .catch(() => {});
    },
    cancelEnroll() {
      api
        .post(
          `${config.url.api}/v1/activities/${this.enroll.enroll_id}/unsubscribe`,
          this.enroll
        )
        .then((res) => {
          if (res.data.s == 12) {
            this.$toast.error(
              this.$t("views.template.enroll_update_cancel_text")
            );
          }
          if (res.data.success) {
            this.$toast.success(
              this.$t("views.template.enroll_update_cancel_succes")
            );
            this.accept(true);
            this.$emit("close-dialog");

            this.delete_dialog = false;
          }
        })
        .catch((err) => {
          switch (err.response.status) {
            case 400:
              this.$toast.error(
                this.$t("views.template.enroll_update_cancel_error")
              );
              break;

            default:
              this.$toast.error(
                this.$t("views.template.enroll_update_cancel_error")
              );
              break;
          }
        });
    },
  },
};
</script>
